import VueRouter from "vue-router";

//page
import Main from "@/components/main";
import OpenLinkPage from "@/components/main/components/openLinkPage";
import MainOld from "@/components/main/index_old";
import Login from "@/components/login";
import LoginSMS from "@/components/login/SMS";
import LoginOTP from "@/components/login/OTP";
import PwConfirm from "@/components/login/pwConform";
import PwReset from "@/components/login/pwReset";
import FindUserId from "@/components/login/FindUserId";
import PhoneReset from "@/components/login/phoneReset";
// import Trade from "@/components/trade";
import Bidding from "@/components/bidding";
import Chart from "@/components/chart";
import RateToReturn from "@/components/RateToReturn";
import Withdraw from "@/components/withdraw";
import WithdrawList from "@/components/withdrawlist";
import TransactionHistory from "@/components/transactionHistory"; //거래내역 new(원화수수료)
import RebaseList from "@/components/rebaseList"; //앰플 리베이스 리스트
import RebaseORICList from "@/components/rebaseORICList"; //오릭 리베이스 리스트
// import Faq from "@/components/faq";
import CsRegist from "@/components/cs/regist"; //1:1 문의 등록
import CsList from "@/components/cs"; //1:1 문의 내역
import CsView from "@/components/cs/view"; //1:1 문의 상세
import Notice from "@/components/notice";
import NoticeView from "@/components/notice/view";
import Event from "@/components/event/BusanEvent";
import EventView from "@/components/event/view";
import Private from "@/components/policy/private";
import Terms from "@/components/policy/terms";
import Company from "@/components/company"; //회사소개페이지
import Management from "@/components/management"; //윤리경영페이지
import ComplaintProcessing from "@/components/complaintProcessing"; //민원처리페이지
import FeeInfo from "@/components/feeInfo"; //민원처리페이지

import MyPage from "@/page/mypage/index.vue";
import Confirm from "@/page/mypage/confirm.vue";
import authAddress from "@/page/mypage/authAddress.vue";
import editWallet from "@/page/mypage/editWallet.vue";
import deleteWallet from "@/page/mypage/deleteWallet.vue";
import localKYC from "@/page/mypage/confirm/localKYC.vue";
import KYCPage from "@/page/mypage/confirm/KYC.vue";
import authID from "@/page/mypage/component/confirm/authIdentity/authID.vue";
import authAccount from "@/page/mypage/component/confirm/auth_bank/authAccount.vue";
import authInfo from "@/page/mypage/component/confirm/authIdentity/authInfo.vue";
import Certification from "@/page/mypage/certification.vue"; //증빙센터
import Asset from "@/page/mypage/asset/index.vue";
import DepositProof from "@/page/mypage/asset/depsitProof.vue";
import DepositKrw from "@/page/mypage/asset/depositKrw.vue";
import DepositCoin from "@/page/mypage/asset/depositCoin.vue";
import WithdrawPage from "@/page/mypage/asset/withdraw.vue";
import withdrawConfirm from "@/page/mypage/asset/withdrawConfirm.vue";
import originWithdrawConfirm from "@/page/mypage/asset/originWithdrawConfirm.vue";
import AssetLog from "@/page/mypage/asset/log.vue";
import leave from "@/page/mypage/leave.vue";
import KycInfo from "@/components/kycInfo"; // 고객확인제도 안내 페이지
import landingpage from "@/page/mypage/component/confirm/authIdentity/landingpage.vue";

// 휴대폰 인증 test용
import authPhoneTest from "@/page/mypage/component/confirm/authIdentity/authPhoneTest.vue";

//#region IEO
import IEOList from "@/components/wow/list";
import IEODetail from "@/components/wow/detail";
//#endregion

import Popup from "@/components/popup";
import Member from "@/components/member";
import OtpConfirm from "@/components/mypage/otpConfirm";
import MypageResidence from "@/components/mypage/residence";
import KYC from "@/components/mypage/KYC";
import ConfirmCenter from "@/components/mypage/confirmCenter";
import ContactInfo from "@/components/mypage/contactInfo";

// 신원인증 ocr test
import OCR from "@/page/mypage/component/confirm/authIdentity/ocrModule.vue";
import OCRtest from "@/page/mypage/component/confirm/authIdentity/ocrtest.vue";

import { COMMON_LAYOUT, ETC_LAYOUT, Controller } from "@/util/controller.js";

const routes = [
  {
    path: "/",
    name: "Main",
    components: COMMON_LAYOUT(Main),
    beforeEnter: Controller,
    meta: {
      isLogin: false,
    },
  },
  // {
  //   path: "/openLink",
  //   name: "openLinkPage",
  //   components: COMMON_LAYOUT(OpenLinkPage),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/old",
  //   name: "MainOld",
  //   components: COMMON_LAYOUT(MainOld),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  {
    path: "/login",
    name: "Login",
    components: COMMON_LAYOUT(Login),
    beforeEnter: Controller,
    meta: {
      isLogin: false,
    },
  },
  // {
  //   path: "/login/SMS",
  //   name: "LoginSMS",
  //   components: COMMON_LAYOUT(LoginSMS),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/login/OTP",
  //   name: "LoginOTP",
  //   components: COMMON_LAYOUT(LoginOTP),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/trade",
  //   name: "Trade",
  //   redirect: "/trade/KRW/BTC",
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/trade/:baseCoin/:dealCoin",
  //   name: "TradeWithCode",
  //   components: COMMON_LAYOUT(Trade),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/bidding",
  //   name: "Bidding",
  //   components: COMMON_LAYOUT(Bidding),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/bidding/:baseCoin/:dealCoin",
  //   name: "BiddingWithCode",
  //   components: COMMON_LAYOUT(Bidding),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/chart",
  //   name: "Chart",
  //   components: COMMON_LAYOUT(Chart),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/chart/:baseCoin/:dealCoin",
  //   name: "ChartWithCode",
  //   components: COMMON_LAYOUT(Chart),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/investments/balance",
  //   name: "RateToReturn",
  //   components: COMMON_LAYOUT(RateToReturn),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/withdraw",
  //   name: "Withdraw",
  //   components: COMMON_LAYOUT(Withdraw),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/withdrawlist",
  //   name: "WithdrawList",
  //   components: COMMON_LAYOUT(WithdrawList),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // 거래내역 new(원화수수료)
  // {
  //   path: "/investments/history",
  //   name: "TransactionHistory",
  //   components: COMMON_LAYOUT(TransactionHistory),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // // //거래내역 new(원화수수료)
  // {
  //   path: "/investments/AMPL",
  //   name: "RebaseList",
  //   components: COMMON_LAYOUT(RebaseList),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/investments/AUSCM",
  //   name: "RebaseORICList",
  //   components: COMMON_LAYOUT(RebaseORICList),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/customer/faq",
  //   name: "Faq",
  //   components: COMMON_LAYOUT(Faq),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/cs/ask",
  //   name: "CsRegist",
  //   components: COMMON_LAYOUT(CsRegist),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/cs/list",
  //   // path: "/customer/cs",
  //   name: "CsList",
  //   components: COMMON_LAYOUT(CsList),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/cs/list/:id",
  //   // path: "/customer/cs/view/:id",
  //   name: "CsView",
  //   components: COMMON_LAYOUT(CsView),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/customer/event",
  //   name: "Event",
  //   components: COMMON_LAYOUT(Event),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/customer/event/view/:id",
  //   name: "EventView",
  //   components: COMMON_LAYOUT(EventView),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/notice",
  //   name: "Notice",
  //   components: COMMON_LAYOUT(Notice),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/notice/view/:id",
  //   name: "NoticeView",
  //   components: COMMON_LAYOUT(NoticeView),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/event",
  //   name: "EventShorcut",
  //   components: COMMON_LAYOUT(Event),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/event/view/:id",
  //   name: "EventViewShorcut",
  //   components: COMMON_LAYOUT(EventView),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  {
    path: "/popup",
    name: "Popup",
    components: COMMON_LAYOUT(Popup),
    beforeEnter: Controller,
    meta: {
      isLogin: false,
    },
  },
  // {
  //   path: "/member",
  //   name: "Member",
  //   components: COMMON_LAYOUT(Member),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  {
    path: "/pw/confirm",
    name: "PwConfirm",
    components: COMMON_LAYOUT(PwConfirm),
    beforeEnter: Controller,
    meta: {
      isLogin: false,
    },
  },
  // {
  //   path: "/pw/reset",
  //   name: "PwReset",
  //   components: COMMON_LAYOUT(PwReset),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/login/find-user-id",
  //   name: "FindUserId",
  //   components: COMMON_LAYOUT(FindUserId),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/login/phoneReset",
  //   name: "PhoneReset",
  //   components: COMMON_LAYOUT(PhoneReset),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/mypage/confirmCenter",
  //   name: "ConfirmCenter",
  //   components: COMMON_LAYOUT(ConfirmCenter),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/otpConfirm",
  //   name: "OtpConfirm",
  //   components: COMMON_LAYOUT(OtpConfirm),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/residence",
  //   name: "MypageResidence",
  //   components: COMMON_LAYOUT(MypageResidence),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/KYC",
  //   name: "KYC",
  //   components: COMMON_LAYOUT(KYC),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/contactInfo",
  //   name: "ContactInfo",
  //   components: COMMON_LAYOUT(ContactInfo),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/landingpage",
  //   name: "landingpage",
  //   components: COMMON_LAYOUT(landingpage),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/policy/private",
  //   name: "PrivatePolicy",
  //   components: COMMON_LAYOUT(Private),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/policy/terms",
  //   name: "TermsOfUse",
  //   components: COMMON_LAYOUT(Terms),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // 회사소개페이지
  // {
  //   path: "/company",
  //   name: "company",
  //   components: COMMON_LAYOUT(Company),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // 수수료 안내
  // {
  //   path: "/fee-information",
  //   name: "feeinfo",
  //   components: COMMON_LAYOUT(FeeInfo),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // 고객확인제도 안내 페이지
  // {
  //   path: "/kyc-info/",
  //   name: "KycInfo",
  //   components: ETC_LAYOUT(KycInfo),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // 윤리경영페이지
  // {
  //   path: "/management",
  //   name: "Management",
  //   components: COMMON_LAYOUT(Management),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  //민원처리페이지
  // {
  //   path: "/complaintProcessing",
  //   name: "ComplaintProcessing",
  //   components: COMMON_LAYOUT(ComplaintProcessing),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  //#region IEO
  // {
  //   path: "/token-swap/list",
  //   name: "IEOList",
  //   components: COMMON_LAYOUT(IEOList),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/token-swap/detail/:tkCode",
  //   name: "IEODetail",
  //   components: COMMON_LAYOUT(IEODetail),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },

  // {
  //   path: "/balances/asset",
  //   name: "asset",
  //   components: COMMON_LAYOUT(Asset),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/balances/deposit/KRW",
  //   // path: "/mypage/deposit/KRW",
  //   name: "depositKrw",
  //   components: COMMON_LAYOUT(DepositKrw),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/balances/deposit/proof",
  //   // path: "/mypage/deposit/proof",
  //   name: "depositProof",
  //   components: COMMON_LAYOUT(DepositProof),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/balances/deposit/:coin",
  //   // path: "/mypage/deposit/:coin",
  //   name: "depositCoin",
  //   components: COMMON_LAYOUT(DepositCoin),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/balances/withdraw/:coin",
  //   // path: "/mypage/withdraw/:coin",
  //   name: "withdrawPage",
  //   components: COMMON_LAYOUT(WithdrawPage),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/balances/withdraw-confirm",
  //   // path: "/mypage/withdrawConfirm",
  //   name: "withdrawConfirm",
  //   components: COMMON_LAYOUT(withdrawConfirm),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/originWithdrawConfirm",
  //   name: "originWithdrawConfirm",
  //   components: COMMON_LAYOUT(originWithdrawConfirm),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/balances/log/:coin",
  //   // path: "/mypage/log/:coin",
  //   name: "assetLog",
  //   components: COMMON_LAYOUT(AssetLog),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/info",
  //   // path: "/mypage/modify",
  //   name: "mypage",
  //   components: COMMON_LAYOUT(MyPage),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/leave",
  //   name: "leave",
  //   components: COMMON_LAYOUT(leave),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/auth",
  //   name: "confirm",
  //   components: COMMON_LAYOUT(Confirm),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/auth-address",
  //   // path: "/mypage/authAddress",
  //   name: "authAddress",
  //   components: COMMON_LAYOUT(authAddress),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/auth-address/edit/:acaidx",
  //   name: "editWallet",
  //   components: COMMON_LAYOUT(editWallet),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/auth-address/delete/:acaidx",
  //   name: "deleteWallet",
  //   components: COMMON_LAYOUT(deleteWallet),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },

  // {
  //   path: "/mypage/confirm/localKYC",
  //   name: "localKYC",
  //   components: COMMON_LAYOUT(localKYC),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/confirm/KYC",
  //   name: "KYCPage",
  //   components: COMMON_LAYOUT(KYCPage),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/component/confirm/authIdentity/authID",
  //   name: "authID",
  //   components: COMMON_LAYOUT(authID),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },

  // {
  //   path: "/ocrtest",
  //   name: "OCRtest",
  //   components: COMMON_LAYOUT(OCRtest),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },

  // {
  //   path: "/ptest",
  //   name: "authPhoneTest",
  //   components: COMMON_LAYOUT(authPhoneTest),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/ocr",
  //   name: "OCR",
  //   components: COMMON_LAYOUT(OCR),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/ocrtest",
  //   name: "OCRtest",
  //   components: COMMON_LAYOUT(OCRtest),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: false,
  //   },
  // },
  // {
  //   path: "/mypage/component/confirm/authAccount",
  //   name: "authAccount",
  //   components: COMMON_LAYOUT(authAccount),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/component/confirm/authIdentity/authInfo",
  //   name: "authInfo",
  //   components: COMMON_LAYOUT(authInfo),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  // {
  //   path: "/mypage/certification",
  //   name: "certification",
  //   components: COMMON_LAYOUT(Certification),
  //   beforeEnter: Controller,
  //   meta: {
  //     isLogin: true,
  //   },
  // },
  //#endregion
  // 404
  {
    path: "*",
    redirect: "/",
  },
];

const Route = new VueRouter({
  routes: routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default Route;
